import { z } from 'zod';
import { FlowBlockValueNumberSchema } from '../../blockValue/numberSchema.js';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export var FlowGetFormSetType;
(function (FlowGetFormSetType) {
    FlowGetFormSetType["UserDefined"] = "userDefined";
    FlowGetFormSetType["AutomaticallyApplied"] = "automaticallyApplied";
    FlowGetFormSetType["AutomaticallyAppliedAll"] = "automaticallyAppliedAll";
})(FlowGetFormSetType || (FlowGetFormSetType = {}));
export var FlowFormSetSearchScope;
(function (FlowFormSetSearchScope) {
    FlowFormSetSearchScope["CurrentPractice"] = "CurrentPractice";
    FlowFormSetSearchScope["AcrossEhrSystem"] = "AcrossEhrSystem";
})(FlowFormSetSearchScope || (FlowFormSetSearchScope = {}));
export const flowGetFormSetLimitNumberSchema = z.number().int().min(1).max(50);
export const flowGetFormSetBlockAutomaticallyAppliedAllLimitSchema = FlowBlockValueNumberSchema({
    numberValidationSchema: flowGetFormSetLimitNumberSchema,
})
    .optional()
    .default('10');
const baseConfig = z.object({
    type: z.enum(FlowGetFormSetType),
    formTemplateId: z.string().optional(),
    primitive: z.string().optional(),
});
const FlowGetFormSetBlockConfigSchema = z.discriminatedUnion('type', [
    baseConfig.extend({
        type: z.literal(FlowGetFormSetType.UserDefined),
        formSetId: z.string(),
    }),
    baseConfig.extend({
        type: z.literal(FlowGetFormSetType.AutomaticallyApplied),
        searchScope: z
            .enum(FlowFormSetSearchScope)
            .optional()
            .default(FlowFormSetSearchScope.CurrentPractice),
    }),
    baseConfig.extend({
        type: z.literal(FlowGetFormSetType.AutomaticallyAppliedAll),
        searchScope: z
            .enum(FlowFormSetSearchScope)
            .optional()
            .default(FlowFormSetSearchScope.CurrentPractice),
        before: z.string().optional(),
        after: z.string().optional(),
        limit: flowGetFormSetBlockAutomaticallyAppliedAllLimitSchema,
    }),
]);
export const FlowGetFormSetBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.GetFormSet),
    config: FlowGetFormSetBlockConfigSchema,
});
//# sourceMappingURL=config.js.map